import { URLS } from '../../../constants';
import apiClient from '../../client';
const getDropdownDataInsuranceAPI = {
    getAllPayorResponsibility: () =>
        apiClient.post(URLS.getAllPayorResponsibility, {
            data: {},
        }),
    getAllInsuranceIdType: () =>
        apiClient.post(URLS.getAllInsuranceIdType, {
            data: {},
        }),
    getAllFillingType: () =>
        apiClient.post(URLS.getAllFillingType, {
            data: {},
        }),
    getAllInsuranceType: () =>
        apiClient.post(URLS.getAllInsuranceType, {
            data: {},
        }),
    //for pre population of payor name field
    getClientPayor: ({
        payorId,
        clientId,
        authorizationCodeId,
    }: {
        payorId: any;
        clientId: any;
        authorizationCodeId: any;
    }) =>
        apiClient.post(URLS.getClientPayor, {
            data: {
                payorId,
                clientId,
                authorizationCodeId,
            },
        }),
    getClientPayorInsurance: ({
        payorId,
        clientId,
        insuranceId,
    }: {
        payorId: any;
        clientId: any;
        insuranceId: any;
    }) =>
        apiClient.post(URLS.getClientPayorInsurance, {
            data: {
                payorId,
                clientId,
                insuranceId,
            },
        }),
};
export default getDropdownDataInsuranceAPI;
